<template>
    <div>
        <CCard class="custom-bg-light-blue p-2 border-16px" style="border:none;">
            <CRow class="m-2">
                <CCol sm="12" md="4" lg="3" class="text-center p-2" v-for="button in buttons" :key="button.value">
                    <div :class="{'blue-background text-white': activeButton === button.value, 'blue-text': activeButton !== button.value, 'custom-padding': activeButton !== button.value}" @click="setActiveButton(button.value)">
                        <img :src="activeButton === button.value ? require(`@/assets/img/icon/${button.activeIcon}`) : require(`@/assets/img/icon/${button.inactiveIcon}`)" style="max-width:20px" class="mr-2" /> {{ button.label }}
                    </div>
                </CCol>
                <CCol sm="12">
                    <div v-if="activeButton === 'Account'">
                        <h3 class="custom-18px-400 mt-3 font-color-101828">Personal Info</h3>
                        <h4 class="custom-16px-400 font-color-667085">Update your personal details</h4>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="2">
                                <div class="text-left">
                                    <h3 class="custom-14px-600 font-color-101828 text-left">Your photo</h3>
                                    <img src="../assets/img/random/Avatar.png" style="max-width:100%" />
                                </div>
                            </CCol>
                            <CCol sm="10">
                                <div class="text-left mt-5">
                                    <br /> <br />
                                    <CButton type="button" class="custom-box-shadow custom-14px-600 font-color-101828">Upload Image</CButton>
                                    <label class="custom-14px-400 font-color-98A2B3 ml-2">JPG or PNG. 1MB max</label>
                                </div>
                            </CCol>
                        </CRow>
                        <CRow class="mt-3">
                            <CCol sm="12">
                                <h3 class="custom-14px-600 font-color-101828 text-left">Full name</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-left">Email</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-left">Phone Number</h3>
                                <CInput type="text" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-left">Date Of Birth</h3>
                                <CInput type="date" />
                            </CCol>
                            <CCol sm="6">
                                <h3 class="custom-14px-600 font-color-101828 text-left">Country</h3>
    
                                <CSelect v-model="selectedOption" :options="customOptions"></CSelect>
    
                                <div class="text-right">
                                    <CButton type="button" class="custom-btn-transparent font-color-101828 mr-2">Cancel</CButton>
                                    <CButton type="button" class="custom-btn-3A70EA text-white">Save</CButton>
                                </div>
    
                            </CCol>
                        </CRow>
                    </div>
                    <div v-if="activeButton === 'Notifications'">
                        <h3 class="custom-18px-400 mt-3 font-color-101828">Notifications</h3>
                        <hr class="custom-hr" />
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-14px-600 font-color-101828 text-left">
                                    Motion Detection Alerts
                                </h3>
                                <h3 class="custom-14px-400 font-color-98A2B3 text-left">
                                    Enable or disable notifications for motion detected by any connected camera
                                </h3>
                            </CCol>
                            <CCol sm="2">
                                <CSwitch class="mx-1 mt-2" color="primary" shape="pill" checked />
                            </CCol>
                        </CRow>
                        <CRow class="mt-2">
                            <CCol sm="10">
                                <h3 class="custom-14px-600 font-color-101828 text-left">
                                    Object Detection Alerts
                                </h3>
                                <h3 class="custom-14px-400 font-color-98A2B3 text-left">
                                    Get notified when specific objects (e.g., packages, vehicles) are detected.
                                </h3>
                            </CCol>
                            <CCol sm="2">
                                <CSwitch class="mx-1 mt-2" color="primary" shape="pill" checked />
                            </CCol>
                        </CRow>
    
                        <CRow class="mt-2">
                            <CCol sm="10">
                                <h3 class="custom-14px-600 font-color-101828 text-left">
                                    Face Detection Alerts
                                </h3>
                                <h3 class="custom-14px-400 font-color-98A2B3 text-left">
                                    Notify when an unrecognized or specific face is detected.
                                </h3>
                            </CCol>
                            <CCol sm="2">
                                <CSwitch class="mx-1 mt-2" color="primary" shape="pill" />
                            </CCol>
                        </CRow>
    
                        <CRow class="mt-2">
                            <CCol sm="10">
                                <h3 class="custom-14px-600 font-color-101828 text-left">
                                    Camera Status Alerts
                                </h3>
                                <h3 class="custom-14px-400 font-color-98A2B3 text-left">
                                    Get updates if a camera goes offline or comes back online.
                                </h3>
                            </CCol>
                            <CCol sm="2">
                                <CSwitch class="mx-1 mt-2" color="primary" shape="pill" />
                            </CCol>
                        </CRow>
    
                        <h3 class="custom-18px-400 mt-4 font-color-101828">Email Notifications</h3>
                        <hr class="custom-hr" />
                        <CRow class="mt-2">
                            <CCol sm="10">
                                <h3 class="custom-16px-500 font-color-101828 text-left">
                                    Daily Summary
                                </h3>
                                <h3 class="custom-14px-400 font-color-98A2B3 text-left">
                                    Receive a daily report of all image detection activities
                                </h3>
                            </CCol>
                            <CCol sm="2">
                                <CSwitch class="mx-1 mt-2" color="primary" shape="pill" />
                            </CCol>
                        </CRow>
                    </div>
    
                    <div v-if="activeButton === 'Configuration'">
                        <CRow>
                            <CCol sm="10">
                                <h3 class="custom-18px-400 mt-3 font-color-101828">Configuration</h3>
                                <h4 class="custom-16px-400 font-color-667085">Update your personal details</h4>
    
                            </CCol>
                            <CCol sm="2">
                                <div class="text-right">
                                    <br /><br />
                                    <CButton type="button" class="custom-btn-3A70EA text-white">Add Camera</CButton>
                                </div>
                            </CCol>
    
                        </CRow>
                        <hr class="custom-hr" />
                        <div v-if="showalllistconfiguration">
                            <table class="table table-responsive-sm table-hover table-outline mb-0 mt-3 ml-15 mr-15" style="border:none">
                                <thead class="bg-f7f7f7 b-20" style="border:none">
                                    <th> <label class="custom-12px-700"><input type="checkbox" class="mr-2"/>Number</label></th>
                                    <th> <label class="custom-12px-700"><img src="../assets/img/icon/video.png" class="mr-2" width="20px"/>Camera</label></th>
                                    <th> <label class="custom-12px-700"><img src="../assets/img/icon/bubble.png" class="mr-2" width="20px"/>Status</label></th>
                                    <th><label class="custom-12px-700"><img src="../assets/img/icon/menu.png" class="mr-2" width="20px"/>Name</label></th>
                                    <th> <label class="custom-12px-700"><img src="../assets/img/icon/location.png" class="mr-2" width="20px"/>Location</label></th>
                                    <th> </th>
                                </thead>
                                <tbody>
                                    <tr>
    
                                        <td><input type="checkbox" class="mr-2" /><label class="custom-14px-500 font-color-666D80">1</label></td>
                                        <td><img src="../assets/img/random/rectangle.png" class="mr-2" width="100px" /></td>
                                        <td> <label class="custom-btn-FEF1ED font-color-F36F4A"><img src="../assets/img/random/dot-orange.png" width="5px"/>  Pending</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">  Front Camera #1</label></td>
                                        <td>Malaysia</td>
                                        <td>
                                            <CDropdown>
                                                <template #toggler>
                                                                        <CHeaderNavLink>
                                                                            <div class="c-avatar">
                                                                            <img
                                                                                src="../assets/img/random/dots-horizontal.png"
                                                                                width="30px"
                                                                            />
                                                                            </div>
                                                                        </CHeaderNavLink>
</template>
                                                <CDropdownItem
                                                @click="OpenDetailConfiguration()"
                                                    >Camera Settings</CDropdownItem
                                                    >
                                                    <CDropdownItem
                                                    ><img src="../assets/img/icon/trash.png" width="20px"/><label class="font-color-F04438 ml-2">Remove</label></CDropdownItem
                                                    >
                                            </CDropdown>
                                        </td>
                                    </tr>
                                    <tr>
                                        
                                        <td><input type="checkbox" class="mr-2"/><label class="custom-14px-500 font-color-666D80">2</label></td>
                                        <td><img src="../assets/img/random/rectangle.png" class="mr-2" width="100px"/></td>
                                        <td>  <label class="custom-btn-FEF1ED font-color-F36F4A"><img src="../assets/img/random/dot-orange.png" width="5px"/>  Pending</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">  Rear Camera #1</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">Malaysia</label></td>
                                        <td> <CDropdown>
<template #toggler>
    <CHeaderNavLink>
        <div class="c-avatar">
            <img src="../assets/img/random/dots-horizontal.png"   width="30px"/>
        </div>
    </CHeaderNavLink>
</template>
                                                <CDropdownItem
                                                @click="OpenDetailConfiguration()"
                                                    >Camera Settings</CDropdownItem
                                                    >
                                                    <CDropdownItem
                                                    ><img src="../assets/img/icon/trash.png" width="20px"/><label class="font-color-F04438 ml-2">Remove</label></CDropdownItem
                                                    >
                                            </CDropdown></td>
                                    </tr>
                                    <tr>
                                        
                                        <td><input type="checkbox" class="mr-2"/><label class="custom-14px-500 font-color-666D80">3</label></td>
                                        <td><img src="../assets/img/random/rectangle.png" class="mr-2" width="100px"/></td>
                                        <td>  <label class="custom-btn-FEF1ED font-color-F36F4A"><img src="../assets/img/random/dot-orange.png" width="5px"/>  Pending</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">  Top Camera #1</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">Malaysia</label></td>
                                        <td> <CDropdown>
<template #toggler>
    <CHeaderNavLink>
        <div class="c-avatar">
            <img src="../assets/img/random/dots-horizontal.png"   width="30px"/>
        </div>
    </CHeaderNavLink>
</template>
                                                <CDropdownItem
                                                @click="OpenDetailConfiguration()"
                                                    >Camera Settings</CDropdownItem
                                                    >
                                                    <CDropdownItem
                                                    ><img src="../assets/img/icon/trash.png" width="20px"/><label class="font-color-F04438 ml-2">Remove</label></CDropdownItem
                                                    >
                                            </CDropdown></td>
                                    </tr>
                                    <tr>
                                        
                                        <td><input type="checkbox" class="mr-2"/><label class="custom-14px-500 font-color-666D80">4</label></td>
                                        <td><img src="../assets/img/random/rectangle.png" class="mr-2" width="100px"/></td>
                                        <td>  <label class="custom-btn-FEF1ED font-color-F36F4A"><img src="../assets/img/random/dot-orange.png" width="5px"/>  Pending</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">  Bottom Camera #1</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">Malaysia</label></td>
                                        <td> <CDropdown>
<template #toggler>
    <CHeaderNavLink>
        <div class="c-avatar">
            <img src="../assets/img/random/dots-horizontal.png"   width="30px"/>
        </div>
    </CHeaderNavLink>
</template>
                                                <CDropdownItem
                                                @click="OpenDetailConfiguration()"
                                                    >Camera Settings</CDropdownItem
                                                    >
                                                    <CDropdownItem
                                                    ><img src="../assets/img/icon/trash.png" width="20px"/><label class="font-color-F04438 ml-2">Remove</label></CDropdownItem
                                                    >
                                            </CDropdown></td>
                                    </tr>
                                    <tr>
                                        
                                        <td><input type="checkbox" class="mr-2"/><label class="custom-14px-500 font-color-666D80">5</label></td>
                                        <td><img src="../assets/img/random/rectangle.png" class="mr-2" width="100px"/></td>
                                        <td>  <label class="custom-btn-FEF1ED font-color-F36F4A"><img src="../assets/img/random/dot-orange.png" width="5px"/>  Pending</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80"> Side Camera #1</label></td>
                                        <td><label class="custom-14px-500 font-color-666D80">Malaysia</label></td>
                                        <td> <CDropdown>
<template #toggler>
    <CHeaderNavLink>
        <div class="c-avatar">
            <img src="../assets/img/random/dots-horizontal.png"   width="30px"/>
        </div>
    </CHeaderNavLink>
</template>
                                                <CDropdownItem
                                                @click="OpenDetailConfiguration()"
                                                    >Camera Settings</CDropdownItem
                                                    >
                                                    <CDropdownItem
                                                    ><img src="../assets/img/icon/trash.png" width="20px"/><label class="font-color-F04438 ml-2">Remove</label></CDropdownItem
                                                    >
                                            </CDropdown></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="showdetailconfiguration">
                            <CRow class="d-flex">
                                <CCol sm="8" class="d-flex">
                                    <CCard class="bg-white border-16px p-3" style="border:none">
                                        <h3 class="custom-18px-600">Front Door Cam #1</h3>
                                        <label @click="BackToAll()"><img src="../assets/img/arrow-left.png" width="25px" @click="BackToAll()"/> Back</label>

                                        <img src="../assets/img/random/maincamera.png" style="max-width:100%" />

                                      
                                    </CCard>

                                </CCol>
                                <CCol sm="4" class="d-flex">
                                    <CCard class="bg-white border-16px p-3" style="border:none">
                                        <CRow>
                                            <CCol sm="12">
                                                <h3 class="custom-16px-600 mt-4">
                                                    Menu
                                                </h3>
                                                <CRow>

                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/videocircle.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Playback</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/gallery.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Gallery</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                            <CCard class="custom-card-EAECF0 p-2">
                                                                <div class="text-center">
                                                                <img src="../assets/img/icon/themecolor.png" width="40px" />
                                                                <h3 class="custom-14px-500 font-color-101828 mt-3">Theme Color</h3>
                                                            </div>

                                                            </CCard>
                                                            </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/privatemode.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Private Mode </h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/nightmode.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Night Mode</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/motiontracking.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Motion Tracking</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/motiondetection.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Motion Detection</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                    <CCol sm="6">

                                                        <CCard class="custom-card-EAECF0 p-2">
                                                            <div class="text-center">
                                                            <img src="../assets/img/icon/cloud.png" width="40px" />
                                                            <h3 class="custom-14px-500 font-color-101828 mt-3">Cloud</h3>
                                                        </div>

                                                        </CCard>
                                                    </CCol>
                                                </CRow>

                                            </CCol>
                                        </CRow>
                                    </CCard>

                                </CCol>
                            </CRow>
                        </div>


                    </div>
    
                    <div v-if="activeButton === 'Language'">
                        <h3 class="custom-18px-400 mt-3 font-color-101828">Personal Info</h3>
                        <h4 class="custom-16px-400 font-color-667085">Update your country details</h4>
                        <hr class="custom-hr" />
                        <CRow>
    
                            <CCol sm="10">
                                <img src="../assets/img/Malaysia.png" width="30px" /> <label class="custom-14px-500 ml-2">Malaysia</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Malaysia"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
                            <CCol sm="10">
                                <img src="../assets/img/flag/indon.png" width="30px" /> <label class="custom-14px-500 ml-2">Indonesian</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Indonesia"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/us.png" width="30px" /> <label class="custom-14px-500 ml-2">English (US)</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="US"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/italy.png" width="30px" /> <label class="custom-14px-500 ml-2">Italy</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Italy"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/france.png" width="30px" /> <label class="custom-14px-500 ml-2">France</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="France"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/germany.png" width="30px" /> <label class="custom-14px-500 ml-2">Germany</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Germany"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/japan.png" width="30px" /> <label class="custom-14px-500 ml-2">Japanese</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Japanese"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/swedish.png" width="30px" /> <label class="custom-14px-500 ml-2">Sweedish</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Sweedish"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
    
                            <CCol sm="10">
                                <img src="../assets/img/flag/russian.png" width="30px" /> <label class="custom-14px-500 ml-2">Russian</label>
                            </CCol>
                            <CCol sm="2">
                                <CInputRadio v-model="flag" name="language" value="Russian"></CInputRadio>
                            </CCol>
                            <CCol sm="12">
                                <hr class="custom-hr" />
                            </CCol>
                        </CRow>
                    </div>
                </CCol>
            </CRow>
        </CCard>
    </div>
</template>



<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);
import _ from "lodash";


import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        VueCal

    },

    data() {
        return {
            activeButton: 'Account', // Default active button
            buttons: [
                { value: 'Account', label: 'Account', activeIcon: 'user-white.png', inactiveIcon: 'user-black.png' },
                { value: 'Notifications', label: 'Notifications', activeIcon: 'noti-white.png', inactiveIcon: 'noti-black.png' },
                { value: 'Configuration', label: 'Configuration', activeIcon: 'config-white.png', inactiveIcon: 'config-black.png' },
                { value: 'Language', label: 'Language', activeIcon: 'global-white.png', inactiveIcon: 'earth-black.png' },
            ],

            selectedOption: null,
            customOptions: [
                { value: "my", label: "Malaysia", flag: "Malaysia.png" },
            ],

            flag: false,
            showalllistconfiguration: true,
            showdetailconfiguration: false










        }





    },
    async mounted() {
        this.getFlagPath();

    },


    methods: {
        setActiveButton(buttonValue) {
            this.activeButton = buttonValue;
        },
        getFlagPath(flagName) {
            try {
                return require(`../assets/img/Malaysia.png`);
            } catch (error) {
                console.error(`Image not found: ${flagName}`, error);
                return ""; // Fallback if image not found
            }
        },
        OpenDetailConfiguration() {
            this.showdetailconfiguration = true;
            this.showalllistconfiguration = false;
        },
        BackToAll() {
            this.showdetailconfiguration = false;
            this.showalllistconfiguration = true;
        }

    }

};
</script>
